import { usePurchasesCheckAvailability } from '@marketplace-web/messaging/messaging-checkout-data'
import { ApplicableTransactionAction } from '@marketplace-web/messaging/conversation-messaging-data'

type UserSide = 'buyer' | 'seller'

type InquiryTransactionActions =
  | ApplicableTransactionAction.Buy
  | ApplicableTransactionAction.RequestOffer
  | ApplicableTransactionAction.Offer

type PurchaseAvailability = ReturnType<typeof usePurchasesCheckAvailability>

const USER_TRANSACTION_ACTIONS: Record<
  UserSide,
  {
    condition: (availability: PurchaseAvailability) => boolean
    actions: Array<InquiryTransactionActions>
  }
> = {
  buyer: {
    condition: ({ user, items }) => user.buy.available && items.buy.available,
    actions: [ApplicableTransactionAction.RequestOffer, ApplicableTransactionAction.Buy],
  },
  seller: {
    condition: ({ items }) => items.buy.available,
    actions: [ApplicableTransactionAction.Offer],
  },
}

// TODO: duplicate of conversation-type-inquiry-feature/src/components/InquiryDetailsHeaderActions/useTransactionActions.ts
function useTransactionActions(itemId: number, userSide: UserSide) {
  const purchasesAvailability = usePurchasesCheckAvailability([itemId])
  const { condition, actions } = USER_TRANSACTION_ACTIONS[userSide]

  if (condition(purchasesAvailability)) return actions

  return []
}

export default useTransactionActions
